﻿
/**
 * Filter drop down list by typing
 * Letter by letter like a love letter.
 * @param {*} evt
 */
 const dropDownFilterByValue = (evt) => {
	let inputValue, filter, ul, li, int;

	filter = evt.target.value.toUpperCase();
	ul = evt.target.parentNode.querySelector('ul.dropdown');
	li = ul.getElementsByTagName("li");

	ul.setAttribute('style', 'display:block');

	for (int = 0; int < li.length; int++) {
		inputValue = li[int].textContent || li[int].innerText;
		li[int].style.display = (inputValue.toUpperCase().indexOf(filter) > -1) ? "" : "none";
	}
}

/**
 * Set Filter drop down field on load.
 */
const setFilterDropdownTextOnLoad = () => {
	for (let filterItem of document.querySelectorAll(".filter-dropdown")) {
		if (filterItem.getAttribute('data-value') !== '') {
			let list = filterItem.parentNode.querySelector('ul.dropdown');
			for (let item of list.querySelectorAll("li")) {
				if (item.getAttribute('data-value') === filterItem.getAttribute('data-value')) {
					filterItem.value = item.querySelector('a').innerText;
				}
			}
		}
	}

	/**
	 * Set filter drop down to disabled if viewMode is copy/edit
	 * and the application is delivery assurance
	 */
	const params = new URLSearchParams(window.location.search);
	if (params.get('viewMode') === 'edit' || params.get('viewMode') === 'copy') {
		document.querySelector("#articleFilter .filter-dropdown").setAttribute('disabled', 'disabled');
	}
}

/**
 * Expand or hide drop down on click
 * To avoid redudant jQarky code.
 * @param {*} self
 * @returns
 */
const expandDropOnClick = (self) => {
	var sub = self.next();
	$('.dropdown').not(sub).hide();

	if (sub.css('display') == 'none') {
		sub.show();
	} else {
		sub.hide();
	}

	return false;
}

const setDropdown = (obj, type)  => {
	obj.find('.showcase > a')
		.unbind('click')
		.click(function () {
			expandDropOnClick($(this));
		}
	);

	if (document.getElementsByClassName('filter-dropdown').length > 0) {
		obj.find('.showcase > input')
			.unbind('click')
			.click(function () {
				expandDropOnClick($(this));
			}
		);

		for (let filterItem of document.querySelectorAll(".filter-dropdown")){
			filterItem.addEventListener("keyup", dropDownFilterByValue);
		}

		setFilterDropdownTextOnLoad();
	}

	obj.find('.showcase .dropdown li a').click(function () {

		var data = $(this).parent().attr('data-value');
		var dataText = $(this).text();
		var dataElement = $(this).parents('.showcase').find('>input[type=hidden]');
		var previousData = dataElement.val();

		$('.dropdown li').removeClass('selected');
		$(this).parent().addClass('selected');

		$(this)
			.parents('.showcase')
			.find('>a')
			.html(type === 'type-2' ? data : dataText);
		$(this).parents('.showcase').find('>a').html(dataText);

		if($(this).parents('.showcase').find('input.filter-dropdown')) {
			$(this).parents('.showcase').find('input.filter-dropdown').val(dataText);
		}

		$(this).parents('.showcase').attr('data-value', data);
		$(this).parents('.showcase').parents().attr('data-designation', dataText);
		dataElement.val(data);

		$('.dropdown li').each(function () {
			$(this).attr('id', `drp_${$(this).attr('data-value')}`);
		});

		if (previousData !== data && (obj.data('triggerChange') || obj.data('triggerchange'))) {
			obj.trigger('change', { data: data, dataText: dataText });
		}

		$(this).parents('.dropdown').hide();
		if ($(this).parent().data('value') === 'Annan') {
			$(this).parents('.model-block').find('input[type="text"]').show();
			$(this).parents('ul.lm__form-dropdown.model-dropdown').hide();
		}

		return false;
	});
}

$(function () {
	const addDataPickerHandler = () => {
		if ($.fn.datepicker && $('.datepicker').length) {
			// Set default options for datepicker
			$.datepicker.setDefaults({
				monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
				monthNames: [
					'Januari',
					'Februari',
					'Mars',
					'April',
					'Maj',
					'Juni',
					'Juli',
					'Augusti',
					'September',
					'Oktober',
					'November',
					'December',
				],
				dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
				firstDay: 0,
				showOtherMonths: true,
				selectOtherMonths: true,
				dateFormat: 'yy-mm-dd',
			});

			$('.datepicker')
				.datepicker({
					defaultDate: new Date(),
					monthNames: [
						'Januari',
						'Februari',
						'Mars',
						'April',
						'Maj',
						'Juni',
						'Juli',
						'Augusti',
						'September',
						'Oktober',
						'November',
						'December',
					],
					dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
					firstDay: 1,
				})
				.datepicker('setDate', new Date())
				.on('change', function () {
					var $this = $(this);
					var validDate = !/Invalid|NaN/.test(new Date($this.val()).toString());
					var validDateRegex = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/gi.test($this.val());

					if (!validDateRegex || !validDate) {
						$this.next().show();
					} else {
						$this.next().hide();
					}
				});
		}
	}

	const addDropDownHandler = () => {
		var dropdown = $('.lm__form-dropdown');

		$(document).on('click touchstart', function (e) {
			var $this = $(e.target);
			if ($this.attr('class') == 'dropdown' || $($this).parents('.lm__form-dropdown').length > 0) {
				return;
			} else {
				$('.dropdown').hide();
			}
		});

		dropdown.each(function () {
			$(this)
				.find('.showcase > a')
				.click(function () {
					expandDropOnClick($(this));
				});

			setDropdown($(this), 'type-2');
			setDropdown($(this), 'type-3');
		});
	}

	addDataPickerHandler();
	addDropDownHandler();
});

export {
	dropDownFilterByValue,
	setFilterDropdownTextOnLoad,
	expandDropOnClick,
	setDropdown
}
